<section class="spinner-container">
  <section class="spinner">
    <ra-ui-loading-spinner id="ra-spinner" size="3rem"></ra-ui-loading-spinner>
    <div>Loading ...</div>
  </section>
</section>
